import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 退職者情報詳細参照API
import {
  IAPI_STA003_Request,
  IAPI_STA003_Response,
} from "../../../type/apiType";

// 退職者詳細情報更新API
import {
  IAPI_STA008_Request,
  IAPI_STA008_Response,
} from "../../../type/apiType";

// 退職者情報詳細参照API
// API仕様書_法人職員
const httpIAPI_STA003 = async (
  param: IAPI_STA003_Request
): Promise<IAPI_STA003_Response> => {
  let res = await http.post(ApiUrl.API_STA003, {
    ...param,
  });

  return res.data;
};

// 退職者詳細情報更新API
// 仕様書_法人職員
const httpIAPI_STA008 = async (
  param: IAPI_STA008_Request
): Promise<IAPI_STA008_Response> => {
  let res = await http.post(ApiUrl.API_STA008, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_STA003, httpIAPI_STA008 };
